import { createFileRoute, Outlet } from '@tanstack/react-router'

import { LightThemeScope } from '@/components/base'

export const Route = createFileRoute('/public')({
  component: PublicLayout,
})

/**
 * Every public page is one fixed white surface, whatever the visitor's OS
 * says. Declared once here so a page — and each of its loading and error
 * branches — is a plain element again.
 */
function PublicLayout() {
  return (
    <LightThemeScope className="flex min-h-0 flex-1 flex-col">
      <Outlet />
    </LightThemeScope>
  )
}
